import React from 'react';
import Sermon from '../../components/Sermon';
import Main from '../../layouts/Main';
import { getSermons } from '../../ajax/sermons';
import Pagination from '@mui/material/Pagination';
import Skeleton from '@mui/material/Skeleton';
import type { Sermon as ISermon } from '@fosterburg/common-ui/types/Sermon';
import { useRouter } from 'next/router';
import type { Pagination as IPagination } from '../../types/Pagination';
import CongregationImage from '../../../public/assets/congregation.jpg';
import Head from 'next/head';
import { CANONICAL_DOMAIN } from '../../utils/constants';

const initialSermons: IPagination<ISermon> = {
  current_page: 0,
  data: [],
  first_page_url: '',
  from: 0,
  last_page: 0,
  last_page_url: null,
  next_page_url: null,
  path: '',
  per_page: 0,
  prev_page_url: null,
  to: 0,
  total: 0,
};

const SermonsPage = (props) => {
  const router = useRouter();
  const [loading, setLoading] = React.useState(false);
  const [paginatedSermons, setSermons] = React.useState<IPagination<ISermon>>(initialSermons);

  React.useEffect(() => {
    if (router.query.page) {
      getNextSermonsPage(router.query.page);
    } else {
      getNextSermonsPage(1);
    }
  }, [router.query.page]);

  function getNextSermonsPage(page) {
    setLoading(true);
    getSermons(page).then((res) => {
      setLoading(false);
      setSermons(res);
    });
  }

  function addPageToQueryParams(page) {
    router.push('/sermons?page=' + page).then(() => window.scrollTo(0, 0));
  }

  const styledPagination = () => (
    <div
      style={{
        paddingBottom: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        textAlign: 'right',
      }}
    >
      <Pagination
        count={paginatedSermons.last_page}
        page={paginatedSermons.current_page}
        shape="rounded"
        onChange={(e, value) => addPageToQueryParams(value)}
      />
    </div>
  );

  return (
    <Main header_title="Sermons" background_image={CongregationImage}>
      <Head>
        <title>Fosterburg Baptist Church | Sermons</title>
        <meta property="og:title" content="Fosterburg Baptist Church | Sermons" key="title" />
        <link rel="canonical" href={`${CANONICAL_DOMAIN}/sermons`} />
      </Head>
      <div style={{ padding: 15 }}>
        {loading && Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} height={330} />)}
        {styledPagination()}
        {paginatedSermons?.data?.map((sermon, i) => (
          <div key={sermon.id} style={{ marginTop: 15 }}>
            <Sermon sermon={sermon} width={500} />
          </div>
        ))}
        {styledPagination()}
      </div>
    </Main>
  );
};

export default SermonsPage;
